var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paperclip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.8667 9.2081L10.2084 16.8664C9.27017 17.8046 7.99769 18.3317 6.67087 18.3317C5.34405 18.3317 4.07157 17.8046 3.13337 16.8664C2.19517 15.9282 1.66809 14.6558 1.66809 13.3289C1.66809 12.0021 2.19517 10.7296 3.13337 9.79144L10.7917 2.1331C11.4172 1.50763 12.2655 1.15625 13.15 1.15625C14.0346 1.15625 14.8829 1.50763 15.5084 2.1331C16.1338 2.75857 16.4852 3.60689 16.4852 4.49144C16.4852 5.37598 16.1338 6.2243 15.5084 6.84977L7.8417 14.5081C7.52897 14.8208 7.10481 14.9965 6.66254 14.9965C6.22026 14.9965 5.79611 14.8208 5.48337 14.5081C5.17064 14.1954 4.99494 13.7712 4.99494 13.3289C4.99494 12.8867 5.17064 12.4625 5.48337 12.1498L12.5584 5.0831",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.0ca2943c9f82925216380298c15ca284.svg";
export { ForwardRef as ReactComponent };